import { describe_error } from '../utils/ErrorDescriber';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import SitePageAnalysis from '../components/SitePageAnalysis';
import AssistantLayout from '../components/AssistantLayout';

import Constants from '../Constants';
import { useAuth } from '../AuthContext';

import '../components/css/aeo-analysis.css';

function AnalysisView({enable_analysis_form}) {
	const navigate = useNavigate();
	const { token } = useAuth();

	// A url on one of the user's sites is analyzed in its site page view, which starts the analysis on arrival; the
	// page is created there first when the crawl never found it. Any other url, or a lookup that fails, is analyzed
	// here.
	const on_before_run = async(url)=>{
		try{
			const response = await axios.get(Constants.SERVER_URL + '/api/site_page_for_url', {
				params: { url },
				headers: { Authorization: 'Bearer ' + token }
			});

			const site_page_id = response.data ? response.data.site_page_id : null;
			if(!site_page_id){
				return false;
			}

			navigate('/site-page/' + site_page_id, { state: { analyze: true } });
			return true;
		}
		catch(error){
			console.log('AnalysisView/on_before_run - ERROR: ', describe_error(error));
			return false;
		}
	};

	const render_content = (on_analysis_change, on_ask_ai)=>{
		return (
			<div className='home-container analysis-view-container'>
				<SitePageAnalysis enable_analysis_form={true} public_view={false} on_analysis_change={on_analysis_change} on_ask_ai={on_ask_ai} on_before_run={on_before_run}/>
			</div>
		);
	};

	return (
		<AssistantLayout render_content={render_content}/>
	);
}

export default AnalysisView;
